export default __webpack_public_path__ + "a8f5df5712560fde8e7073032dfa1b45.png";